/**
 * Löwenschmiede — Scroll Animations + Google Reviews Auto-Load
 * Handles:
 *  1. Intersection Observer for .animate-on-scroll and section elements
 *  2. Google review card staggered reveal
 *  3. Google Places API auto-fetch (if Place ID + API key are provided via data attrs)
 */
(function () {
  'use strict';

  /* ─── 1. IntersectionObserver: opt-in scroll animations ─── */
  function initScrollAnimations() {
    var reviewCards = document.querySelectorAll('.google-review-card');
    var genericAnimels = document.querySelectorAll('.animate-on-scroll');

    // Only animate elements that explicitly opt in with .animate-on-scroll
    if (genericAnimels.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
      );
      genericAnimels.forEach(function (el) { observer.observe(el); });
    }

    // Staggered review cards
    var reviewObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            var delay = Array.from(reviewCards).indexOf(entry.target) * 80;
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, delay);
            reviewObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -20px 0px' }
    );

    reviewCards.forEach(function (card) { reviewObserver.observe(card); });
  }

  /* ─── 2. Google Places: auto-fetch reviews ─── */
  function initGoogleReviews() {
    var container = document.getElementById('google-reviews-live');
    if (!container) return;

    var placeId = container.dataset.placeId;
    var apiKey  = container.dataset.apiKey;
    if (!placeId || !apiKey || placeId === '' || apiKey === '') return;

    var endpoint =
      'https://maps.googleapis.com/maps/api/place/details/json?place_id=' +
      encodeURIComponent(placeId) +
      '&fields=rating,user_ratings_total,reviews&language=de&key=' +
      encodeURIComponent(apiKey);

    // Note: Direct browser calls to Places API require a CORS proxy or
    // a server-side proxy endpoint. We use a window.__REVIEWS_PROXY if provided,
    // otherwise fall back to the static Shopify blocks.
    var proxyUrl = window.__REVIEWS_PROXY_URL;
    var fetchUrl = proxyUrl ? proxyUrl + '?place_id=' + placeId : null;

    if (!fetchUrl) return; // No proxy available; static blocks are shown.

    fetch(fetchUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.result) return;
        var result = data.result;

        // Update aggregate badge
        var ratingEl = document.getElementById('google-rating-value');
        var countEl  = document.getElementById('google-reviews-count');
        if (ratingEl && result.rating) {
          ratingEl.textContent = String(result.rating).replace('.', ',');
        }
        if (countEl && result.user_ratings_total) {
          countEl.textContent = result.user_ratings_total;
        }

        // Render review cards
        var reviews = (result.reviews || []).filter(function (r) { return r.rating >= 4; });
        if (reviews.length === 0) return;

        var row = container.querySelector('.google-reviews-row');
        if (!row) return;

        row.innerHTML = reviews.slice(0, 6).map(function (rev, idx) {
          var initial = (rev.author_name || 'G')[0].toUpperCase();
          var colours = ['#CA151A', '#1A73E8', '#0F9D58', '#F4B400', '#7B1FA2', '#E64A19'];
          var bg = colours[idx % colours.length];
          var stars = '★★★★★'.slice(0, rev.rating);
          var relTime = rev.relative_time_description || '';

          return (
            '<div class="google-review-card">' +
              '<div class="google-review-card__header">' +
                '<div class="google-review-card__avatar">' +
                  '<div style="width:40px;height:40px;background:' + bg + ';display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;">' + initial + '</div>' +
                '</div>' +
                '<div>' +
                  '<div class="google-review-card__name">' + escHtml(rev.author_name) + '</div>' +
                  '<div class="google-review-card__stars">' + stars + '</div>' +
                  '<div class="google-review-card__time">' + escHtml(relTime) + '</div>' +
                '</div>' +
              '</div>' +
              '<div class="google-review-card__quote">' + escHtml(rev.text || '') + '</div>' +
            '</div>'
          );
        }).join('');

        // Re-observe newly inserted cards
        document.querySelectorAll('.google-review-card').forEach(function (card) {
          card.style.opacity = '0';
        });
        initScrollAnimations();
      })
      .catch(function () {
        // Silently fall back to static blocks
      });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─── Init ─── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollAnimations();
      initGoogleReviews();
    });
  } else {
    initScrollAnimations();
    initGoogleReviews();
  }

})();
